export default __webpack_public_path__ + "static/media/rar.19d62a9c.svg";